var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "VideoBg"
  }, [_c('video', {
    ref: "video",
    attrs: {
      "autoplay": "",
      "loop": "",
      "muted": "",
      "playsinline": ""
    }
  }, _vm._l((_vm.sources), function(source) {
    return _c('source', {
      attrs: {
        "src": source,
        "type": _vm.getMediaType(source)
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "VideoBg__content"
  }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65807d96","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/videobg.vue
// module id = 7
// module chunks = 0 1